import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Announcement, AnnouncementFailure, AnnouncementSuccess, AnnouncementActionTypes } from '../actions/announcementActions';
import { ViewAnnouncement, ViewAnnouncementFailure, ViewAnnouncementSuccess } from '../actions/announcementActions';
import { ChangeAnnStatus, ChangeAnnSuccess, ChangeAnnFailure } from '../actions/announcementActions';
import { SingleAnnouncement,SingleAnnouncementFailure,SingleAnnouncementSuccess } from '../actions/announcementActions';
import { RequestAnnouncement,RequestAnnouncementFailure,RequestAnnouncementSuccess } from '../actions/announcementActions';
import { Search,SearchFailure,SearchSuccess } from '../actions/announcementActions';
import { AnnouncementService } from 'src/app/modules/dashboard/addannouncements/announcement.service';
import { ViewannouncementsService } from 'src/app/modules/dashboard/viewannouncements/viewannouncements.service';
import { ListviewService } from 'src/app/pages/listview/listview.service';

import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';


@Injectable()
export class AnnouncementEffects {

  constructor(
    private actions: Actions,
    private announcementService: AnnouncementService,
    private viewAnnouncementService: ViewannouncementsService,
    private listViewService: ListviewService
    

  ) { }

  
 
  @Effect()
  SingleAnnouncement: Observable<any> = this.actions
    .ofType(AnnouncementActionTypes.SINGLE_ANNOUNCEMENT)
    .map((action: SingleAnnouncement) => action.payload)
    @Effect()
    RequestAnnouncement: Observable<any> = this.actions
    .ofType(AnnouncementActionTypes.REQUEST_ANNOUNCEMENT)
    .map((action: RequestAnnouncement) => action.payload)
    
    @Effect()
    Search: Observable<any> = this.actions
    .ofType(AnnouncementActionTypes.SEARCH_ANNOUNCEMENT)
    .map((action: Search) => action.payload)
    .mergeMap(payload => {
      console.log(payload);
      return this.listViewService.searchAnnouncement(payload)
        .map((data) => {
          console.log("request", data);
          if (!data.success) {
            return new SearchFailure({ error: data });
          }
          return new SearchSuccess({
            success: data.success,
            successMessage: data.message,
            data: data.data
          });

        })
        .catch((error) => {
          return Observable.of(new SearchFailure({ error: error }));
        });
    });
}

